module.exports = __webpack_public_path__ + "img/BannerWeb_2.a6e51450.png";